import { BatchCheckPermissionRequestSchema } from '@raystack/frontier';
import {
  FrontierServiceQueries,
  create,
  useQuery
} from '@raystack/frontier/hooks';

interface PermissionCheck {
  permission: string;
  resource: string;
}

export const useUserHasPermissions = (
  permissions: PermissionCheck[] | undefined
) => {
  const { data: pairs = [], isLoading: loadingPermissions } = useQuery(
    FrontierServiceQueries.batchCheckPermission,
    create(BatchCheckPermissionRequestSchema, {
      bodies: permissions
    }),
    {
      enabled: !!permissions && permissions.length > 0,
      select: response => response?.pairs || []
    }
  );

  return {
    loadingPermissions,
    permissions: pairs
  };
};
